import React from 'react';
import { makeStyles } from '@mui/styles';

import GiftLayout, { IGiftLayoutProps } from '../../../../components/Layout/GiftLayout';

const useStyles = makeStyles(() => ({
  message: {
    '@media (min-width: 769px)': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
}));

export interface ICodeLayoutProps extends Omit<IGiftLayoutProps, 'overrideClasses'> {}

const CodeLayout = (props: ICodeLayoutProps): JSX.Element => {
  const classes = useStyles();
  return <GiftLayout {...props} overrideClasses={classes} />;
};

export default CodeLayout;
